@if (is_master || is_diretor) {
  <div class="frete-page">
    <!-- Header -->
    <div class="page-header">
      <div>
        <h4>Gestão de Frete</h4>
        <p>Regras de frete por faixa de valor de pedido</p>
      </div>
      <button class="btn-add" type="button" (click)="abrirNovo()">+ Nova Faixa</button>
    </div>
    <!-- Tabela -->
    <div class="card-section">
      <div class="section-title">Faixas Cadastradas</div>
      @if (carregando) {
        <div class="text-center py-4 text-secondary">Carregando...</div>
      }
      @if (!carregando) {
        <div class="tabela-grid">
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>Subsegmento 2</th>
                <th class="text-right">Vlr Mínimo</th>
                <th class="text-right">Vlr Máximo</th>
                <th class="text-right">Frete</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (item of itens; track item) {
                <tr>
                  <td>
                    @if (item.client_subsegmento2) {
                      <span class="badge-seg">{{ item.client_subsegmento2 }}</span>
                    }
                    @if (!item.client_subsegmento2) {
                      <span class="text-muted-italic">Geral</span>
                    }
                  </td>
                  <td class="text-right">{{ item.valor_minimo | currency:'BRL' }}</td>
                  <td class="text-right">
                    @if (item.valor_maximo != null) {
                      <span>{{ item.valor_maximo | currency:'BRL' }}</span>
                    }
                    @if (item.valor_maximo == null) {
                      <span class="text-muted-italic">∞</span>
                    }
                  </td>
                  <td class="text-right">{{ item.frete | currency:'BRL' }}</td>
                  <td class="text-right text-nowrap">
                    <button class="btn-row btn-row-edit" type="button" (click)="abrirEditar(item)">Editar</button>
                    <button class="btn-row btn-row-danger ml-1" type="button" (click)="excluir(item)">Excluir</button>
                  </td>
                </tr>
              }
              @if (itens.length === 0) {
                <tr>
                  <td colspan="5" class="text-center py-4 text-secondary" style="font-style:italic">Nenhuma regra de frete cadastrada.</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="frete-page">
    <div class="alert alert-warning">Acesso restrito a Master e Diretoria.</div>
  </div>
}


<!-- Modal -->
@if (mostrarModal) {
  <div class="modal-overlay">
    <div class="modal-card">
      <div class="modal-header-bar">
        <h5>{{ label }}</h5>
        <button type="button" class="btn-close-modal" (click)="fecharModal()">&times;</button>
      </div>
      <div class="modal-body-pad">
        <div class="form-grid">
          <!-- Subsegmento 2 — visível apenas se houver opções -->
          @if (opcoesSubsegmento2.length > 0) {
            <div class="field">
              <label>Subsegmento 2</label>
              <select class="form-control form-control-sm" [(ngModel)]="form.client_subsegmento2">
                <option value="">— Geral (sem filtro) —</option>
                @for (op of opcoesSubsegmento2; track op) {
                  <option [value]="op">{{ op }}</option>
                }
              </select>
              <span class="helper-text">Vazio = regra aplicada a todos os clientes</span>
            </div>
          }
          <div class="form-grid cols-2">
            <div class="field">
              <label>Valor Mínimo <span class="req">*</span></label>
              <div class="input-group input-group-sm">
                <div class="input-group-prepend"><span class="input-group-text h-100">R$</span></div>
                <input class="form-control" type="number" min="0" step="0.01" [(ngModel)]="form.valor_minimo" />
              </div>
            </div>
            <div class="field">
              <label>Valor Máximo</label>
              <div class="input-group input-group-sm">
                <div class="input-group-prepend"><span class="input-group-text h-100">R$</span></div>
                <input class="form-control" type="number" min="0" step="0.01" [(ngModel)]="form.valor_maximo" placeholder="∞" />
              </div>
              <span class="helper-text">Vazio = sem limite superior</span>
            </div>
          </div>
          <div class="field">
            <label>Valor do Frete <span class="req">*</span></label>
            <div class="input-group input-group-sm">
              <div class="input-group-prepend"><span class="input-group-text h-100">R$</span></div>
              <input class="form-control" type="number" min="0" step="0.01" [(ngModel)]="form.frete" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer-bar">
        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="fecharModal()">Cancelar</button>
        <button class="btn-save" type="button" (click)="salvar()" [disabled]="salvando">
          {{ salvando ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </div>
  </div>
}
